import { validateStaffPin } from '@/features/kitchen/kitchenStaff'
import { apiFetch } from '@/shared/api/client'
import { runKitchenSync } from '@/shared/sync/kitchenSync'

import { isMockApi } from '@/shared/env'
export type AttendanceAction = 'check_in' | 'check_out'

export type SubmitAttendanceRequest = {
  deviceId: string
  userId: string
  pin: string
  action: AttendanceAction
  photoUrl: string
}

export type SubmitAttendanceResponse = {
  recorded_at: string
  on_time?: boolean
  authority?: 'full' | 'attendance_only'
  head_present?: boolean
}

function useMockApi(): boolean {
  return isMockApi
}

function mockSubmit(req: SubmitAttendanceRequest): SubmitAttendanceResponse {
  if (!validateStaffPin(req.userId, req.pin)) {
    throw new Error('PIN tidak cocok dengan nama staff. Gunakan PIN pribadi masing-masing.')
  }
  if (!req.photoUrl) {
    throw new Error('Foto selfie wajib diambil.')
  }
  return {
    recorded_at: new Date().toISOString(),
    on_time: req.action === 'check_in',
  }
}

export async function submitAttendanceDirect(
  req: SubmitAttendanceRequest,
): Promise<SubmitAttendanceResponse> {
  if (useMockApi()) {
    await new Promise((resolve) => setTimeout(resolve, 500))
    return mockSubmit(req)
  }

  const path = req.action === 'check_in' ? '/attendance/check-in' : '/attendance/check-out'

  return apiFetch<SubmitAttendanceResponse>(path, {
    method: 'POST',
    body: JSON.stringify({
      device_id: req.deviceId,
      user_id: req.userId,
      pin: req.pin,
      photo_url: req.photoUrl,
    }),
  })
}

export async function submitAttendance(
  req: SubmitAttendanceRequest,
): Promise<SubmitAttendanceResponse> {
  const actionLabel = req.action === 'check_out' ? 'Keluar' : 'Masuk'
  return runKitchenSync(
    {
      type: 'attendance',
      label: `Absensi ${actionLabel}`,
      payload: req,
    },
    () => submitAttendanceDirect(req),
    () => ({
      recorded_at: new Date().toISOString(),
      on_time: req.action === 'check_in',
    }),
  )
}
